import { combineReducers } from "redux";
import LoginReducer from "./LoginReducer";
import UserReducer from "./UserReducer";
import SignupReducer from "./SignupReducer"
import ProfileReducer from "./ProfileReducer"
import ProfitReducer from "./ProfitReducer"
import marketReducer from './marketReducer'; // <-- add

const RootReducer = combineReducers({
  login: LoginReducer,
  user: UserReducer,
  signup: SignupReducer,
  profiledata: ProfileReducer,
  dailyprofitdata: ProfitReducer,
  market:marketReducer,
});

export default RootReducer;
